<template>
	<ul class="menu icons">
		<li>
			<ul class="menu-popup" :class="{ visible: isOpened }">
				<li><button @click="openStatusDialog">System status</button></li>
				<li><button v-if="isAdmin" @click="listPublicKeys">Access Keys</button></li>
				<li><button @click="openGitPullWizard()">Git Config Pull</button></li>
				<li><button @click="openGitConfigDialog('Push')">Git Config Push</button></li>
				<li><button @click="openTestRunner()">Run Tests</button></li>
				<li><button @click="openGitConfigDialog('Upload')">Upload file</button></li>
				<li><button @click="openVersions()">Import progress</button></li>
				<li><button @click="openLogs()">Import logs</button></li>
			</ul>
			<button class="menu-popup-toggle" @click="toggle">
				<i class="fad fa-gear"></i>
			</button>
		</li>
		<StatusDialog ref="statusDialog" />
		<GitConfigDialog ref="gitConfigDialog" />
        <LogsTableDialog ref="logsTableDialog"/>
		<ImportEverythingDialog ref="importEverythingDialog" :results="results"/>
		<versions-dialog ref="VersionsDialog" @selectversions="selectedVersion"/>
	</ul>
</template>

<script>
import StatusDialog from './StatusDialog';
import GitConfigDialog from "../git-config/GitConfigDialog";
import ImportEverythingDialog from '../git-config/ImportEverythingDialog'
import VersionsDialog from '../shared/VersionsDialog';
import LogsTableDialog from "../git-config/LogsTableDialog";

export default {
	name: 'SettingsDropdown',
	props: ['isAdmin'],
	components: {
		StatusDialog,
		VersionsDialog,
		ImportEverythingDialog,
		GitConfigDialog,
        LogsTableDialog
	},
	data: function() {
		return {
			versionsOpened: false,
			isOpened: false,
			results: null
		};
	},
	methods: {
		toggle: function() {
			this.isOpened = !this.isOpened;
		},
		openStatusDialog () {
			this.$refs.statusDialog.open();
		},
		openGitConfigDialog(type) {
			this.$refs.gitConfigDialog.show(type);
		},
		openGitPullWizard() {
			this.$router.push({ name: 'GitPull' });
		},
		openTestRunner() {
			this.$router.push({ name: 'RunTests' });
		},
		selectedVersion: function(conflict) {
			this.versionsOpened = true;
			conflict.chosen.progress.forEach(element => {
				element.isProgress = true;
				element.showBodyString = JSON.stringify(element.showBody)
				element.showBody = {};
			});
            
			this.results = conflict.chosen.progress;
			this.$refs.importEverythingDialog.open(conflict.chosen.progress[0]);
			//this.$refs.conflictEditDialog.show(JSON.parse(JSON.stringify(conflict)));
		},
		listPublicKeys() {
			this.$router.push({ name: 'PublicKeyList' });
		},
		openVersions: function() {
			let filter = {
				page: 0,
				size: 10,
				backupType: "CONFIGURATION",
				domainClassName : "GitConfigRequest"
			};
			this.$refs.VersionsDialog.show(filter);
		},
        openLogs: function() {
			this.$refs.logsTableDialog.show();
		},
	}
};
</script>
